/**
 * 页面 SEO 配置（SSR 友好）
 * CSS 已全局加载（nuxt.config.ts css 数组），无需在此处理
 * @param {{ title: string, description?: string, bodyId?: string }} options
 */
export function usePageSeo(options) {
  const { title, description, bodyId } = options

  useSeoMeta({
    title,
    description: description || title,
    ogTitle: title,
    ogDescription: description || title,
    twitterCard: 'summary_large_image',
  })

  if (bodyId) {
    useHead({
      bodyAttrs: { id: bodyId, class: bodyId },
    })
  }
}
